export const CURRENCIES: Array<string> = ['USD', 'MXN'];
